import * as z from "zod";

export const applyOptimizationDraft = {
  name: "applyOptimizationDraft" as const,
  input: z.object({
    draftId: z.bigint(),
    fields: z.array(z.string()).optional(),
  }),
  output: z.void(),
};
